import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  ls,
  f,
  useMsgz,
  BoxC,
  BtnCttC,
  IptC,
  LblC,
  GridC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as LblC from "./_cccLblC";
import * as BtnCttC from "./_ccmBtnCttC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import { useMsgz } from "./_csMdlMsg";
import * as ht from './_ht';
import * as hf from './_hf';

import * as ica from 'src/ica';

import * as icvi16 from './icvI16___Mz';

let $i16z = icvi16.ilzI16z();

export const B = (pz: ht.btnCttCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          //hf.l(`IcvI16b 42: here`);
          const _i16rz = $i16z.i16rz;
          const _b = await hf.ectSrlAsync([
            async () => { // 必須項目の確認
              let _b = true;
              if (
                !hf.f(_i16rz._icn) || // 部屋ID
                !hf.f(_i16rz._pfx) // 部屋名
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '必須項目が入力されていないため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
          ])
          if (_b) {
            const _i16z = await icvi16.saveI16rDzAsync({
              ... pz,
              i16z: $i16z,
            });
            //hf.l(`IcvI16b 47: ${hf.s(_i16z)}`);
            return {
              i16r_fst :_i16z.i16rz._fst,
            };
          }
        }
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz) => {

  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {
    //hf.l(`IcvI16b 61: ${pz.sPz.crt.phs}, ${pz.sPz.crt.i16r_fst}`);
    cmFTH.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      crtAsync: () => [
        icvi16.crtI16zAsync()
        .then((_dz: ht.dz) => {
          //hf.l(`IcvI16b 67: ${hf.s(_dz)}`);
          $i16z = _dz;
        })
      ],
      udtAsync: () => [
        icvi16.loadI16rDzAsync({
          i16r_fst: pz.sPz.crt.i16r_fst,
          vsn: pz.sPz.crt.vsn,
        })
        .then((_dz: ht.dz) => {
          //hf.l(`IcvI16b 76: ${hf.s(_dz)}`);
          $i16z = _dz;
        })
      ],
    });
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt.i16r_fst,
    pz.sPz.crt.vsn
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  //hf.l(`Icvi16b 64: ${hf.s($i16z)}`);
  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
        cr.c(TextC.N, {
          key: -5,
          abtType: 'rmkCmnz',
          boxStlz: a(`dw/f fd/rsc mb/1`),
          textz: {
            pfx: '※：必須'
          }
        })
        : null,

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/2 mh/a'),
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: 'ジャンルID：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i16z?.i16rz._icn ?? '',
                              onChg: ( _s: ht.s ) => {
                                $i16z.i16rz._icn = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/18`),
                        textz: {
                          pfx: 'ジャンル名：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i16z?.i16rz._pfx ?? '',
                              onChg: ( _s: ht.s ) => {
                                $i16z.i16rz._pfx = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
          ]
        }),

      ]
    })
  );
};

